export enum AutoResponsiveKey {
    Mode = 'mode',
    LastGroupingsHash = 'lastGroupingsHash',
    IsSynced = 'isSynced'
}
